import React from 'react'

import RegularOnsiteRightCreateSections from './RegularOnsiteRightCreateSections'
import GamOnsiteRightCreateSections from './GamOnsiteRightCreateSections'

import { useIsGamAccountConnectedToRightsHolderAccount } from './GamOnsiteRightCreateSections/hooks'

const OnsiteRightCreateSections = ({ formik }) => {
  const isGamAccountConnected = useIsGamAccountConnectedToRightsHolderAccount()

  if (isGamAccountConnected) {
    return <GamOnsiteRightCreateSections formik={formik} />
  } else {
    return <RegularOnsiteRightCreateSections formik={formik} />
  }
}

export default OnsiteRightCreateSections
